import React from "react";

const Gal = () => {
  return (
    <>
      <div className="ins-flw">
        Follow
        <a className="green" href="https://www.instagram.com/_qubit.tech/">
          @_qubit.tech
        </a>
      </div>
      <div id="gallery">
        <div className="lay">
          <img src="./imgs/g1.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g-2.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g3.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g4.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g-5.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g-6.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g-7.jpg" alt="" />
        </div>
        <div className="lay">
          <img src="./imgs/g-8.jpg" alt="" />
        </div>
      </div>
    </>
  );
};

export default Gal;
